import { render } from "./WorkerRatesTab.vue?vue&type=template&id=6440dfde&ts=true"
import script from "./WorkerRatesTab.vue?vue&type=script&lang=ts"
export * from "./WorkerRatesTab.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__